/** Change this value to clear SVG caches. Mash your keyboard until you have plenty of characters. */
export const svgCacheBuster = 'mula7ceffglkf928nldkf930x478n0rq437y50q3874yrq088sj30B29flsFGH34asoip'
